up.event = (function () {
    const u = up.util;
    const e = up.element;
    function reset() {
        for (let globalElement of [window, document, e.root, document.body]) {
            for (let listener of up.EventListener.allNonDefault(globalElement)) {
                listener.unbind();
            }
        }
    }
    function on(...args) {
        return buildListenerGroup(args).bind();
    }
    function onClosest(fragment, eventType, callback) {
        let guard = (event) => event.target.contains(fragment);
        let unsubscribe = up.on(eventType, { guard }, callback);
        up.destructor(fragment, unsubscribe);
        return unsubscribe;
    }
    function off(...args) {
        return buildListenerGroup(args).unbind();
    }
    function buildListenerGroup(args, options) {
        return up.EventListenerGroup.fromBindArgs(args, options);
    }
    function buildEmitter(args) {
        return up.EventEmitter.fromEmitArgs(args);
    }
    function emit(...args) {
        return buildEmitter(args).emit();
    }
    function build(...args) {
        const props = u.extractOptions(args);
        const type = args[0] || props.type || up.fail('Missing event type');
        const event = new Event(type, { bubbles: true, cancelable: true });
        Object.assign(event, u.omit(props, ['type', 'target']));
        return event;
    }
    function assertEmitted(...args) {
        return buildEmitter(args).assertEmitted();
    }
    function onEscape(listener) {
        return on('keydown', function (event) {
            if (event.key === 'Escape') {
                return listener(event);
            }
        });
    }
    function halt(event, options = {}) {
        if (options.log)
            up.log.putsEvent(event);
        event.stopImmediatePropagation();
        event.preventDefault();
    }
    const keyModifiers = ['metaKey', 'shiftKey', 'ctrlKey', 'altKey'];
    function isModified(event) {
        return (event.button > 0) || u.some(keyModifiers, (modifier) => event[modifier]);
    }
    function isSyntheticClick(event) {
        return u.isMissing(event.clientX);
    }
    function fork(originalEvent, newType, copyKeys = []) {
        const newEvent = build(newType, u.pick(originalEvent, copyKeys));
        newEvent.originalEvent = originalEvent;
        ['stopPropagation', 'stopImmediatePropagation', 'preventDefault'].forEach(function (key) {
            const originalMethod = newEvent[key];
            return newEvent[key] = function () {
                originalEvent[key]();
                return originalMethod.call(newEvent);
            };
        });
        if (originalEvent.defaultPrevented) {
            newEvent.preventDefault();
        }
        return newEvent;
    }
    function executeEmitAttr(event, element) {
        if (isModified(event)) {
            return;
        }
        const eventType = e.attr(element, 'up-emit');
        const eventProps = e.jsonAttr(element, 'up-emit-props');
        const forkedEvent = fork(event, eventType);
        Object.assign(forkedEvent, eventProps);
        up.emit(element, forkedEvent);
    }
    on('up:click', '[up-emit]', executeEmitAttr);
    let inputDevices = ['unknown'];
    function getInputDevice() {
        return u.last(inputDevices);
    }
    function observeInputDevice(newModality) {
        inputDevices.push(newModality);
        setTimeout(() => inputDevices.pop());
    }
    on('keydown keyup', { capture: true }, () => observeInputDevice('key'));
    on('pointerdown pointerup', { capture: true }, () => observeInputDevice('pointer'));
    on('up:framework:reset', reset);
    return {
        on,
        onClosest,
        off,
        build,
        emit,
        assertEmitted,
        onEscape,
        halt,
        isModified,
        isSyntheticClick,
        fork,
        keyModifiers,
        get inputDevice() { return getInputDevice(); }
    };
})();
up.on = up.event.on;
up.off = up.event.off;
up.emit = up.event.emit;
